import { environment } from './../../environments/environment';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NzImageService } from 'ng-zorro-antd/image';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  MediaObject,
  MediaStructure,
  YoutubeResult,
} from '@app/shared/interfaces/MediaStructure';
import { MediaService } from '@app/shared/services/Media.service';
import { LayoutService } from '@app/shared/services/layout.service';
import { AppConfigService } from '@app/shared/services/app-config.service';
@Component({
  selector: 'app-media-holder',
  templateUrl: './MediaHolder.component.html',
  styleUrls: ['./MediaHolder.component.less'],
  providers: [NzImageService],
})
export class MediaHolderComponent implements OnInit {
  _objectKey: number = 0;
  @Input() mediaStructures: MediaStructure[];
  @Input() IsMain: boolean;
  @Input() ObjectType: number;
  @Input() set ObjectKey(value: number) {
    this._objectKey = value;
    this.GetObjectMedia();
    setTimeout(() => {
      this.ImagesMedia = this.mediaStructures.filter(
        (x) =>
          (x.type.startsWith('image') || x.type.startsWith('link')) &&
          x.isHidden !== true
      );
      this.filesMedia = this.mediaStructures.filter(
        (x) =>
          !x.type.startsWith('image') &&
          !x.type.startsWith('link') &&
          x.isHidden !== true
      );
      this.ImagesCover = this.mediaStructures.filter(
        (x) => x.type.startsWith('image') && x.isHidden === true
      );
      this.buildCollapseOrSection();
    }, 1000);
 
  }
  get ObjectKey() {
    return this._objectKey;
  }
  @Input() YoutubeAPIKey: string;
  @Output() fileUploaded = new EventEmitter();
  @Output() FileRomoved = new EventEmitter();
  covertUrl: string;
  coverID: string;
  hideSlider: boolean;
  ImagesMedia: MediaStructure[];
  ImagesCover: MediaStructure[];
  filesMedia: MediaStructure[];
  IsCollapse = true;
  JustImages: boolean;
  JustFiles: boolean;
  fileRowCount: number;
  size: number;
  DrawerVisible: boolean;
  base64Str: string;
  LinkType: string;
  mediaLink: string;
  linkTitle: string;
  linkRols: string[];
  youtubeResult: YoutubeResult;
  videoDesciption: string;
  constructor(
    private nzImageService: NzImageService,
    private mediaService: MediaService,
    private modal: NzModalService,
    private message: NzMessageService,
    private layoutService: LayoutService
  ) {}

  ngOnInit(): void {
    // this.GetObjectMedia();
    this.coverID = '0';
    this.LinkType = 'I';
    this.DrawerVisible = false;
    this.hideSlider = false;
    const savedSize = localStorage.getItem('MediaSize');
    if (savedSize !== undefined && savedSize !== null) {
      this.size = Number(savedSize);
    } else {
      this.size = 150;
    }
  }

  GetObjectMedia() {
    this.mediaService
      .getObjectMedia(this.ObjectType, this.ObjectKey)
      .subscribe((data: any) => {
        let RealDate: MediaObject[] = data;
        this.mediaStructures = [];
        this.ImagesMedia = [];
        this.ImagesCover = [];
        this.filesMedia = [];
        RealDate.forEach((media) => {
          const tmpUploadFile: MediaStructure = {
            id: '11',
            fileID: '2',
            name: 'test',
            data: '',
            thumbData: '',
            previewData: '',
            type: '',
            originalName: '',
            extension: '',
            appInfo: '',
            isUploading: false,
            AltText: '',
            width: 0,
            height: 0,
            FileSize: 0,
            mediaLink: '',
            isHidden: false,
            isLink: false,
            HightPercent: 0,
            TopPercent: 0,
            widthPercent: 0,
            leftPercent: 0,
            Roles: [],
          };
          const id = media.id;
          tmpUploadFile.id = id.toString();

          const FileId = media.fileId;
          tmpUploadFile.fileID = FileId.toString();

          const Type = media.type;
          tmpUploadFile.type = Type;

          const AppInfo = media.appInfo;
          tmpUploadFile.appInfo = AppInfo;

          const Postion = media.postion;
          tmpUploadFile.Position = Number(Postion);

          const name = media.fileName;
          tmpUploadFile.originalName = name;

          const extension = media.fileExtension;
          tmpUploadFile.extension = extension;

          const data = media.data;
          if (data !== undefined && data !== null) {
            tmpUploadFile.data = data.toString();
          } else {
            tmpUploadFile.data = '';
          }
          const MediaLink = media.mediaLink;
          tmpUploadFile.mediaLink = MediaLink;
          const isLink = media.isLink;
          tmpUploadFile.isLink = Boolean(isLink);
          if (!tmpUploadFile.isLink) {
            tmpUploadFile.thumbData = 'data:' + Type + ';base64,' + data;
          } else {
            tmpUploadFile.thumbData = data;
          }

          const size = media.fileSize;
          tmpUploadFile.FileSize = Number(size);

          const width = media.width;
          tmpUploadFile.width = Number(width);
          const Height = media.height;
          tmpUploadFile.height = Number(Height);

          const isHidden = media.isHidden;
          tmpUploadFile.isHidden = Boolean(isHidden);

          const isVideo = media.isVideo;
          tmpUploadFile.isVideo = Boolean(isVideo);

          const altText = media.altText;
          tmpUploadFile.AltText = altText;

          const Roles = media.roles;
          if (Roles !== null && Roles !== undefined) {
            tmpUploadFile.Roles = Roles.split(',');
          }

          if (tmpUploadFile.height >= tmpUploadFile.width) {
            tmpUploadFile.HightPercent = 100;
            tmpUploadFile.widthPercent =
              (tmpUploadFile.width * 100) / tmpUploadFile.height;
            tmpUploadFile.leftPercent =
              (tmpUploadFile.HightPercent - tmpUploadFile.widthPercent) / 2;
            tmpUploadFile.TopPercent = 0;
          } else {
            tmpUploadFile.widthPercent = 100;
            tmpUploadFile.HightPercent =
              (tmpUploadFile.height * 100) / tmpUploadFile.width;
            tmpUploadFile.TopPercent =
              (tmpUploadFile.widthPercent - tmpUploadFile.HightPercent) / 2;
            tmpUploadFile.leftPercent = 0;
          }
          tmpUploadFile.Percent = 100;
          tmpUploadFile.isUploading = false;
          tmpUploadFile.isError = false;
          this.mediaStructures.push(tmpUploadFile);
        });
      });
  }
  SaveObjectMedia() {
    if (this.ObjectKey === undefined || this.ObjectKey == null) {
      return;
    }
    this.mediaService.updateObjectMedia(
      this.ObjectType,
      this.ObjectKey,
      this.mediaStructures
    );
  }
  drop(event: any) {
    moveItemInArray(this.ImagesMedia, event.previousIndex, event.currentIndex);
  }
  buildCollapseOrSection() {
    if (this.ImagesMedia.length > 0 && this.filesMedia.length > 0) {
      this.IsCollapse = true;
      this.JustImages = false;
      this.JustFiles = false;
    } else {
      this.IsCollapse = false;
      if (this.ImagesMedia.length > 0) {
        this.JustImages = true;
        this.JustFiles = false;
      } else {
        this.JustImages = false;
        this.JustFiles = true;
      }
    }
  }
  Download(mediaStrucure: MediaStructure) {
    const link = `${AppConfigService.settings.apiUrl}Media/file/${mediaStrucure.fileID}/`;
    window.open(link);
  }
  removeFile(mediaStrucure: MediaStructure) {
    this.modal.confirm({
      nzTitle: this.layoutService.translate(
        'Are you sure you want to remove this Media?'
      ),
      nzOkText: this.layoutService.translate('Yes'),
      nzCancelText: this.layoutService.translate('No'),
      nzOnOk: () => {
        this.mediaService.RemoveMedia(mediaStrucure,this.ObjectKey).subscribe((x: any) => {
          this.mediaStructures = this.mediaStructures.filter(
            (z) => z.id !== mediaStrucure.id
          );
          if (mediaStrucure.isImage) {
            this.ImagesMedia = this.ImagesMedia.filter(
              (z) => z.id !== mediaStrucure.id
            );
          } else {
            this.filesMedia = this.filesMedia.filter(
              (w) => w.id !== mediaStrucure.id
            );
          }

          this.buildCollapseOrSection();
        });
        this.FileRomoved.emit(mediaStrucure.id);
        return true;
      },
    });
  }
  parentPreview(mediaStrucure: MediaStructure) {
    if (mediaStrucure.isImage) {
      this.nzImageService.preview(this.buildPreviewArray(mediaStrucure), {
        nzZIndex: 2147483646,
        nzZoom: 1,
        nzRotate: 0,
      });
    } else {
      this.Download(mediaStrucure);
    }
  }
  fileDownload(mediaStrucure: MediaStructure) {
    this.Download(mediaStrucure);
  }
  onSliderChange(value: any) {
    {
      this.size = value;
    }
  }
  ChangeRole(mediaStrucure: MediaStructure) {
    const startIndex = this.ImagesMedia.findIndex(
      (x) => x.id === mediaStrucure.id
    );
    mediaStrucure.mustUpdate = true;
    for (let i = 0; i < this.ImagesMedia.length; i++) {
      if (i !== startIndex) {
        const tmpImg = this.ImagesMedia[i];
        const l1 = tmpImg.Roles.length;
        tmpImg.Roles = tmpImg.Roles.filter(
          (x) => !mediaStrucure.Roles.find((y) => x === y)
        );
        const l2 = tmpImg.Roles.length;
        if (l1 !== l2) {
          tmpImg.mustUpdate = true;
        }
      }
    }
  }
  onLinkDrawerClose() {
    this.DrawerVisible = false;
  }
  uploadLink() {
    this.DrawerVisible = true;
  }
  onCloseDrawer(mediaStrucure: MediaStructure) {
    // const startIndex = this.ImagesMedia.findIndex(
    //   (x) => x.id === mediaStrucure.id
    // );
    // this.mediaService
    //   .updateImagedata(mediaStrucure)
    //   .subscribe((x: any) => {
    //     mediaStrucure.mustUpdate = false;
    //   });
    // for (let i = 0; i < this.ImagesMedia.length; i++) {
    //   if (startIndex !== i) {
    //     const tmpImg = this.ImagesMedia[i];
    //     if (tmpImg.mustUpdate === true) {
    //       this.mediaService
    //         .updateImagedata(tmpImg)
    //         .subscribe((x: any) => {
    //           tmpImg.mustUpdate = false;
    //         });
    //     }
    //   }
    // }
  }
  zoomInOut(indicater: number) {
    if (indicater === 0) {
      const tmp = this.size - 10;
      if (tmp > 150) {
        this.size -= 10;
      }
    } else {
      const tmp = this.size + 10;
      if (tmp < 1000) {
        this.size += 10;
      }
    }

    localStorage.setItem('MediaSize', this.size.toString());
  }
  handleFileInput(event: any) {
    let files = event.target.files;
    const fileList: FileList = files;
    for (let i = 0; i < fileList.length; i++) {
      const tmpFile = fileList[i];
      const isImage = tmpFile.type.startsWith('image');
      const tmpMediaStructure: MediaStructure = {
        id: 'upload' + i,
        fileID: '',
        name: '',
        data: '',
        thumbData: '',
        previewData: '',
        type: tmpFile.type,
        originalName: tmpFile.name,
        extension: '',
        appInfo: 'excel',
        isUploading: true,
        AltText: '',
        width: 0,
        height: 0,
        FileSize: 0,
        mediaLink: '',
        isHidden: false,
        isLink: false,
        HightPercent: 0,
        TopPercent: 0,
        widthPercent: 0,
        leftPercent: 0,
        Roles: [],
      };
      if (isImage) {
        this.ImagesMedia.push(tmpMediaStructure);
      } else {
        this.filesMedia.push(tmpMediaStructure);
      }
      this.mediaStructures.push(tmpMediaStructure);
      this.buildCollapseOrSection();
      this.upload(tmpMediaStructure, i, fileList[i], false);
    }
  }
  handleLinkInput() {
    const tmpMediaStructure: MediaStructure = {
      id: '0',
      fileID: '0',
      name: '',
      data: '',
      thumbData: this.mediaLink,
      previewData: '',
      type: 'link',
      originalName: this.linkTitle,
      extension: '',
      appInfo: this.LinkType === 'I' ? 'Pic' : 'Vid',
      isUploading: true,
      AltText: this.linkTitle,
      width: this.size,
      height: this.size,
      FileSize: 0,
      mediaLink: this.mediaLink,
      isHidden: false,
      isLink: true,
      HightPercent: 100,
      TopPercent: 0,
      widthPercent: 100,
      leftPercent: 0,
      Roles: this.linkRols,
      CoverID: this.coverID,
      isImage: this.LinkType === 'I' ? true : false,
      isVideo: this.LinkType === 'V' ? true : false,
    };
    this.ImagesMedia.push(tmpMediaStructure);
    this.mediaStructures.push(tmpMediaStructure);
    this.buildCollapseOrSection();
    this.mediaService.uploadLink(tmpMediaStructure).subscribe((d: any) => {
      tmpMediaStructure.id = d.result.tmpUploadFile.id;
      tmpMediaStructure.fileID = d.result.tmpUploadFile.fileID;
      tmpMediaStructure.isUploading = false;
      this.DrawerVisible = true;
      this.fileUploaded.emit(tmpMediaStructure);
    });
  }
  handleCoverFileInput(files: any) {
    const tmpFile = files.target.files[0];
    const isImage = tmpFile.type.startsWith('image');
    if (!isImage) {
      return;
    }
    const tmpMediaStructure: MediaStructure = {
      id: 'upload' + 0,
      fileID: '',
      name: '',
      data: '',
      thumbData: '',
      previewData: '',
      type: tmpFile.type,
      originalName: tmpFile.name,
      extension: '',
      appInfo: 'excel',
      isUploading: true,
      AltText: '',
      width: 0,
      height: 0,
      FileSize: 0,
      mediaLink: '',
      isHidden: true,
      isLink: false,
      HightPercent: 0,
      TopPercent: 0,
      widthPercent: 0,
      leftPercent: 0,
      Roles: [],
    };
    this.ImagesCover.push(tmpMediaStructure);
    this.upload(tmpMediaStructure, this.ObjectKey, tmpFile, true);
  }
  upload(
    tmpMediaStructure: MediaStructure,
    idx: number,
    file: any,
    isCover: boolean
  ) {
    tmpMediaStructure.Percent = 0;
    if (tmpMediaStructure.isImage) {
      // this.ReadFileData(file);
    }
    this.mediaService
      .upload(file, isCover, this.ObjectKey, this.ObjectType)
      .subscribe(
        (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            tmpMediaStructure.Percent = Math.round(
              (100 * event.loaded) / event.total
            );
          } else if (event instanceof HttpResponse) {
            const tmpUploadFile = event.body.dbPath.tmpUploadFile;
            tmpMediaStructure.isUploading = false;
            tmpMediaStructure.id = tmpUploadFile.id;
            tmpMediaStructure.fileID = tmpUploadFile.fileID;
            tmpMediaStructure.originalName = tmpUploadFile.name;
            tmpMediaStructure.type = tmpUploadFile.type;
            tmpMediaStructure.appInfo = tmpUploadFile.appInfo;
            tmpMediaStructure.thumbData =
              'data:' +
              tmpMediaStructure.type +
              ';base64,' +
              tmpUploadFile.data;
            tmpMediaStructure.width = Number(tmpUploadFile.width);
            tmpMediaStructure.height = Number(tmpUploadFile.height);
            if (tmpMediaStructure.height >= tmpMediaStructure.width) {
              tmpMediaStructure.HightPercent = 100;
              tmpMediaStructure.widthPercent =
                (tmpMediaStructure.width * 100) / tmpMediaStructure.height;
              tmpMediaStructure.leftPercent =
                (tmpMediaStructure.HightPercent -
                  tmpMediaStructure.widthPercent) /
                2;
              tmpMediaStructure.TopPercent = 0;
            } else {
              tmpMediaStructure.widthPercent = 100;
              tmpMediaStructure.HightPercent =
                (tmpMediaStructure.height * 100) / tmpMediaStructure.width;
              tmpMediaStructure.TopPercent =
                (tmpMediaStructure.widthPercent -
                  tmpMediaStructure.HightPercent) /
                2;
              tmpMediaStructure.leftPercent = 0;
            }
            if (isCover) {
              this.covertUrl = tmpMediaStructure.thumbData;
              this.coverID = tmpMediaStructure.fileID;
            }
        
            this.fileUploaded.emit(tmpUploadFile);
          }
        },
        (err) => {
          tmpMediaStructure.Percent = 0;
          tmpMediaStructure.ErrorMessage =
            'Could not upload the file:' + file.name;
        }
      );
  }
  ReadFileData(file: any) {
    const reader = new FileReader();

    reader.onload = this._handleReaderLoaded.bind(this);

    reader.readAsBinaryString(file);
  }
  _handleReaderLoaded(readerEvt: any) {
    const binaryString = readerEvt.target.result;
    this.base64Str = btoa(binaryString);

  }
  buildPreviewArray(mediaStrucure: MediaStructure) {
    const enlargPX = 1000;
    const images = [];
    const startIndex = this.ImagesMedia.findIndex(
      (x) => x.id === mediaStrucure.id
    );
    images.push({
      src: mediaStrucure.thumbData,
      width: (mediaStrucure.widthPercent * enlargPX) / 100 + 'px',
      height: (mediaStrucure.HightPercent * enlargPX) / 100 + 'px',
      alt: 'ng-zorro',
    });
    for (let i = startIndex + 1; i < this.ImagesMedia.length; i++) {
      if (!this.ImagesMedia[i].isVideo) {
        images.push({
          src: this.ImagesMedia[i].thumbData,
          width: (this.ImagesMedia[i].widthPercent * enlargPX) / 100 + 'px',
          height: (this.ImagesMedia[i].HightPercent * enlargPX) / 100 + 'px',
          alt: 'ng-zorro',
        });
      }
    }
    for (let i = 0; i < startIndex; i++) {
      if (!this.ImagesMedia[i].isVideo) {
        images.push({
          src: this.ImagesMedia[i].thumbData,
          width: (this.ImagesMedia[i].widthPercent * enlargPX) / 100 + 'px',
          height: (this.ImagesMedia[i].HightPercent * enlargPX) / 100 + 'px',
          alt: 'ng-zorro',
        });
      }
    }
    return images;
  }
  getYoutubeAPIEmedURL() {
    const tmpUrl = this.mediaLink;
    let vedioID = '';
    if (tmpUrl.indexOf('embed') !== -1) {
      const linkElements = tmpUrl.split('/');
      vedioID = linkElements[linkElements.length - 1];
    } else if (tmpUrl.indexOf('watch') !== -1) {
      const linkElements = tmpUrl.split('=');
      vedioID = linkElements[linkElements.length - 1];
      this.mediaLink = `https://www.youtube.com/embed/${vedioID}`;
    } else {
      vedioID = tmpUrl;
      this.mediaLink = `https://www.youtube.com/embed/${vedioID}`;
    }
    return vedioID;
  }
  getYouTubeInfo() {
    if (this.mediaLink === undefined || this.mediaLink === '') {
      return;
    }
    if (this.LinkType === 'V') {
      const VideoID = this.getYoutubeAPIEmedURL();
      this.mediaService
        .getYoutubeVideoInfo(VideoID, this.YoutubeAPIKey)
        .subscribe((d: any) => {
          this.youtubeResult = d;
          if (this.youtubeResult.items.length === 0) {
            this.message.error('no Information for this video');
            return;
          }
          this.covertUrl =
            this.youtubeResult !== undefined
              ? this.youtubeResult.items[0].snippet.thumbnails.high.url!
              : '';
          this.linkTitle =
            this.youtubeResult !== undefined
              ? this.youtubeResult.items[0].snippet.title
              : '';
          this.videoDesciption =
            this.youtubeResult.items[0].snippet.description;
          this.coverID = '0';
        });
    } else if (this.LinkType === 'I') {
    }
  }
  YTDurationToHour(duration: any) {
    let match = duration.match(/PT(\d+H)?(\d+M)?(\d+S)?/);

    match = match.slice(1).map((x: any) => {
      if (x != null) {
        return x.replace(/\D/, '');
      }
    });

    // tslint:disable-next-line: radix
    const hours = parseInt(match[0]) || 0;
    // tslint:disable-next-line: radix
    const minutes = parseInt(match[1]) || 0;
    // tslint:disable-next-line: radix
    const seconds = parseInt(match[2]) || 0;

    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
}
